import {
  fetchGroupProductsBasic,
  uniqueByHandle,
  sortByCurrentHandle,
} from "./product-groups-core";

type ProductNode = {
  handle: string;
  title: string;
  metafield: { value: string | null } | null;
};

function renderFragrances(
  container: HTMLElement,
  products: ProductNode[],
  currentHandle: string,
) {
  container.innerHTML = "";
  const fragment = document.createDocumentFragment();
  for (const product of products) {
    const fragrance = product.metafield?.value?.trim();
    const label = fragrance && fragrance.length > 0 ? fragrance : product.title;
    const link = document.createElement("a");
    link.className = "block-swatch";
    link.textContent = label;
    if (product.handle === currentHandle) {
      link.setAttribute("aria-current", "page");
      link.classList.add("is-selected");
    } else {
      const root = window.Shopify?.routes?.root ?? "/";
      link.href = `${root}products/${product.handle}`;
    }
    fragment.appendChild(link);
  }
  container.appendChild(fragment);
}

async function initProductGroups(groupContainer: HTMLElement) {
  const groupTag = groupContainer.getAttribute("data-group-tag");
  const currentHandle =
    groupContainer.getAttribute("data-current-handle") || "";
  if (!groupTag) return;

  const valuesRow = groupContainer.querySelector<HTMLElement>(
    '[data-row="fragrance"]',
  );
  if (!valuesRow) return;
  if (
    valuesRow.childElementCount > 0 ||
    valuesRow.hasAttribute("data-preloaded")
  ) {
    groupContainer.classList.remove("is-loading");
    return;
  }

  try {
    const products = await fetchGroupProductsBasic(groupTag);
    const uniqueProducts = uniqueByHandle(products);
    const sorted = sortByCurrentHandle(uniqueProducts, currentHandle);
    renderFragrances(valuesRow, sorted, currentHandle);
  } finally {
    groupContainer.classList.remove("is-loading");
  }
}

function mountProductGroups(root: ParentNode = document) {
  const containers = root.querySelectorAll<HTMLElement>("[data-color-groups]");
  containers.forEach((container) => void initProductGroups(container));
}

const init = () => mountProductGroups();
document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", init)
  : init();

document.addEventListener("shopify:section:load", () => mountProductGroups());
